export const TabLockedHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: 'Expediente',
                    type: 'custom-html',
                    key: 'accreditation_applications',
                    modifier: (value) => {
                        return `<a href="/accreditations/applications/${value.id}" target="_blank">${value.record || ''}</a>`;
                    }
                },
                {
                    title: 'Tipo solicitud',
                    type: 'custom-html',
                    key: 'accreditation_applications',
                    modifier: (value) => {
                        return value.accreditation_activity.name;
                    }
                },
                {
                    title: 'Tipo acreditación',
                    type: 'custom-html',
                    key: 'accreditation_applications',
                    modifier: (value) => {
                        return value.accreditation_type.name;
                    }
                },
                {
                    title: 'Tipo',
                    type: 'custom-html',
                    key: 'type',
                    modifier: (item) => {
                        return item == 'E' ? 'Evaluación' : 'Testificación';
                    }
                },
                {
                    title: 'Código',
                    type: 'text',
                    key: 'code',
                },
                {
                    title: this.$t('Planificado Desde'),
                    type: 'custom-html',
                    key: 'date_start',
                    modifier: (value) => {
                        if (value) {
                            return moment(value).format("DD-MM-YYYY");
                        }
                    }
                },
                {
                    title: this.$t('Planificado Hasta'),
                    type: 'custom-html',
                    key: 'date_end',
                    modifier: (value) => {
                        if (value) {
                            return moment(value).format("DD-MM-YYYY");
                        }
                    }
                },
                {
                    title: 'Observación',
                    type: 'custom-html',
                    key: 'historical_last2',
                    modifier: (item) => {
                        let tmp = 'N/A';
                        if (item.length == 2 && item[1].status.code == '210') tmp = `<span class="badge badge-sm badge-pill badge-danger">Convenio Rechazado</span>`;
                        return tmp;
                    }
                },
                {
                    title: 'Agrupado',
                    type: 'custom-html',
                    key: 'key_combo',
                    modifier: (item) => {
                        if(item){
                            return `<span class="badge badge-sm badge-pill badge-primary">Por ${item}</span>`;
                        }else{
                            return 'N/A';
                        }
                    }
                },
                {
                    title: 'Días Disponibles',
                    type: 'custom-html',
                    key: 'eval_test_time',
                    modifier: (value) => {
                        let tmp;
                        if (value) {
                            if (value.remaining_days > 1) {
                                tmp = `<span class="badge badge-sm badge-pill badge-success">${value.remaining_days}</span>`;
                            }
                            if (value.remaining_days == 1) {
                                tmp = `<span class="badge badge-sm badge-pill badge-warning">${value.remaining_days}</span>`;
                            }
                            if (value.remaining_days == 0) {
                                tmp = `<span class="badge badge-sm badge-pill badge-danger">${value.remaining_days}</span>`;
                            }
                        }
                        return tmp;
                    }
                },
            ],
            actionObj: {
                title: this.$t('action'),
                type: 'action',
            }
        }
    },
}